import dayjs from "dayjs";

export const getCurrentStrDate = () => {
	const now = new Date();
	return dayjs(`${now.getFullYear()}-${now.getMonth()}-${now.getDay()}`);
};

export const getCurrentDayjsDate = () => {
	const now = new Date();
	return dayjs(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`);
};

export const parseDateFromStr = (str, format) => {
	return dayjs(str, format);
};

export const stringifyDayjs = (str, format) => {
	return dayjs(str).format(format);
};

export const yearMonthDayToStrDate = ({ year, month, day }) => {
	let _month = month;
	let _day = day;

	if (String(_month).length === 1) _month = `0${_month}`;
	if (String(_day).length === 1) _day = `0${_day}`;

	return `${year}-${_month}-${_day}`;
};

export const dateToYearMonthDay = ({ dateStr }) => {
	const dateObj = new Date(dateStr);
	return { year: dateObj.getFullYear(), month: dateObj.getMonth() + 1, day: dateObj.getDate() };
};
